import styled from "styled-components";
import BaseLoader from "react-loader-spinner";
import {space, Space} from "style/spacing";

export const StyledLoader = styled(BaseLoader)<Space>`
  display: flex;
  justify-content: center;

  ${space};
`;